import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-shipment-packaging-info',
  templateUrl: './shipment-packaging-info.component.html',
  styleUrls: ['./shipment-packaging-info.component.scss']
})
export class ShipmentPackagingInfoComponent implements OnInit {
    @Input() packaging!: any;
    @Input() weight!: number;
    @Input() price!: number;

  constructor() { }

  ngOnInit(): void {
  }

}
